import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useAOS from "../shared/useAos";


export default function CarouselModule({data, tittle}) {
useAOS();

    const responsive = {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1
        },
        tablet: {
          breakpoint: { max: 1024, min: 768 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 768, min: 0 },
          items: 1,
        }
      };

  return (
         <div
      data-aos="fade-left"
      data-aos-delay="300"
      data-aos-duration="600"
      className="my-16 p-10 w-full"
    >
      <h1 className="text-center text-2xl md:text-3xl mt-4 font-bold">
        {tittle}
      </h1>

      <Carousel infinite responsive={responsive}>
        {data.map((d, index) => (
          <div
            key={index}
            className="flex items-center justify-center lg:p-6"
          >
            <img
              src={d.img}
              className="rounded-3xl object-cover h-[60vh] lg:h-[75vh] w-full lg:w-3/4"
              alt=""
            />
          </div>
        ))}
      </Carousel>
    </div>
  )

}


